import React from "react";
import { default as Body } from "/application/webos/webos_tv_emulator/Body";
import { default as Footer } from "/application/webos/webos_tv_emulator/Footer";

export default function RightOverlay({
  pageJSON,
  simPageNum,
  singleScreenStep,
  setIsSingleStepScreen,
  setSingleScreenStepLength,
}) {
  return (
    <div
      style={{
        background: pageJSON[simPageNum].content_data.right_overlay_color,
        animation: pageJSON[simPageNum].content_data.fade_in_delay
          ? `.5s fadeIn ${pageJSON[simPageNum].content_data.right_fade_in_delay} linear forwards`
          : null,
        width: "50%",
        height: "100%",
        position: "absolute",
        right: "0",
        top: "",
        opacity: pageJSON[simPageNum].content_data.fade_in_delay ? "0" : "1",
        zIndex: "3",
      }}
    >
      {pageJSON[simPageNum].content_data.right_content ? (
        <Body myJSON={pageJSON[simPageNum]} side="right" />
      ) : null}
      {pageJSON[simPageNum].content_data.right_content &&
      pageJSON[simPageNum].content_data.right_content.footer ? (
        <Footer
          myJSON={pageJSON[simPageNum].content_data.right_content.footer}
          singleScreenStep={singleScreenStep}
          setIsSingleStepScreen={setIsSingleStepScreen}
          setSingleScreenStepLength={setSingleScreenStepLength}
        />
      ) : null}
    </div>
  );
}
